export const BATCH_TIMEOUT = 10
